import { Injectable } from '@angular/core';
import { AuthServices } from '@app/core/services/auth.services';

@Injectable()
export class LoginFacade {
  constructor(private authService: AuthServices) {}

  login() {
    this.authService.authorize();
  }
}
